import React from "react";
import HelmetSeo from "../../components/Site/Reusable/HelmetSeo";
import Hero from "../../components/Site/Reusable/Hero";
import SpacingItem from "../../components/Site/Reusable/SpacingItem";
import TitleDescription from "../../components/Site/Reusable/TitleDescription";
import CyberInfo from "../../components/Site/Reusable/CyberInfo";

import "../../assets/siem.scss";
import "../../assets/services.scss";
import RelatedServices from "../../components/Site/Reusable/RelatedServices";
import QualysService from "../../components/Site/Sections/TehnologySolutions/QualysService";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { fetchSeoListItems } from "../../actions/Site/global";
import { useEffect } from "react";

const Qualys = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { dataPagesListSeo } = useSelector((state) => state.globalReducer);

  useEffect(() => {
    dispatch(fetchSeoListItems(10));
  }, [dispatch]);
  return (
    <div className="page-holder-main-content">
      <HelmetSeo
        title={dataPagesListSeo.length > 0 && dataPagesListSeo[0].acTitle}
        description={
          dataPagesListSeo.length > 0 && dataPagesListSeo[0].acDescription
        }
        keywords={dataPagesListSeo.length > 0 && dataPagesListSeo[0].acKeywords}
      />
      <Hero title={t("qualys.title")} img={`qualys-hero.png`} />
      <SpacingItem />
      <CyberInfo text={t("qualys.desc")} />
      <TitleDescription
        title={t("qualys.title2")}
        description={t("qualys.desc2")}
        button={t("qualys.btn2")}
        link={`services#vulnerabilityManagement`}
      />
      <QualysService t={t} />
      <RelatedServices
        title={t("related.title")}
        text1={t("related.qualys.title1")}
        link1={t("related.qualys.link1")}
        text2={t("related.qualys.title2")}
        link2={t("related.qualys.link2")}
        text3={t("related.qualys.title3")}
        link3={t("related.qualys.link3")}
        buttonTitle={t("related.button")}
      />
    </div>
  );
};

export default Qualys;
